import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Modal, Card } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faEye, faPen, faPlus, faTrash, faFilter, faSync 
} from '@fortawesome/free-solid-svg-icons';
import useFetch from "../../../hooks/useFetch";
import RequireRoles from '../../../components/RequireRoles';
import PaginatedItems from '../../../components/administracao/Pagination';

export default function GerenciarInventarios() {
    // https://create-react-app.dev/docs/adding-custom-environment-variables/
    const { params } = useParams(); // pega o que vem depois da barra na url
    const { get, del } = useFetch();

    const defaultState = {
        inventarios: [],
        count: 0,
        page: 1,
        filtroAtivo: false,
        filtros: {
            data_inventario: "",
            observacao: ""
        },
        mostrarModal: false,
        registroAExcluir: {
            id_item: "",
            id_usuario: " "
        },
        loading: true
    };

    // Roda quando a página é carregada https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    const [state, setState] = useState(() => {
        return defaultState;
    });

    useEffect(() => {
        async function initialize() {
            let [inventarios, count] = await buscarInventarios({});
            setState({ ...state, inventarios: inventarios, count: count, loading: false });
        }
        initialize();
    }, [params]);

    // função de paginação
    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let filtroPaginacao = { page: pageNumber };
        if (state.filtroAtivo) {
            filtroPaginacao = { ...filtroPaginacao, page: pageNumber };
        }
        let [inventarios, count] = await buscarInventarios(filtroPaginacao);
        setState({ ...state, page: pageNumber, inventarios: inventarios, count: count, loading: false });
    }

    // Busca os dados do banco
    async function buscarInventarios(filtros) {
        if (!state.loading) setState({ ...state, loading: true });

        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") {
                    query = query.concat(key, "=", filtros[key], "&");
                }
            }
        }
        try {
            let response = await get('/inventario' + query);
            if (response.ok) {
                let dados = response.result;
                return [dados.data, dados.count];
            } else {
                console.error('Erro no buscarInventarios()');
                return [];
            }
        } catch (error) {
            console.error('Erro no buscarInventarios():', error);
        }
    }

    // Função acionada quando o usuário clica em buscar
    async function filtrarInventarios() {
        // adiciona os dados no objeto filtros se eles não forem vazios
        // Busca os dados do banco com os filtros
        let [inventarios, count] = await buscarInventarios(state.filtros);
        // Atualiza o estado com os dados buscados
        setState({ ...state, inventarios: inventarios, filtroAtivo: true, count: count, loading: false });
    }

    async function limparFiltros() {
        // Busca os dados do banco sem filtros
        let [inventarios, count] = await buscarInventarios({});
        // Atualiza o estado com os dados buscados e reseta os valores dos campos de filtro
        setState({ ...state, filtros: defaultState.filtros, filtroAtivo: false, inventarios: inventarios, count: count, loading: false });
    }

    function handleChangeFiltros(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        // se for dropdown, pega o valor selecionado
        if (target.type === 'select-one') {
            value = target.options[target.selectedIndex].value;
        }

        setState({
            ...state,
            filtros: {
                ...state.filtros,
                [name]: value
            }
        });
    }

    function confirmarExclusao(item) {
        setState({ ...state, mostrarModal: true, registroAExcluir: item });
    }

    async function excluirInventario() {
        let inventario = state.registroAExcluir;
        try {
            let response = await del('/inventario/' + inventario.Item.id_item + '/' + inventario.sec_inventario);
            if (response.ok) {
                let [inventarios, count] = await buscarInventarios({});
                setState({ ...state, inventarios: inventarios, mostrarModal: false, registroAExcluir: {}, count: count, loading: false });
            }
            else {
                console.error('Erro no excluirInventario()');
            }
        } catch (error) {
            console.error('Erro no excluirInventario():', error);
        }
    }

    function fecharModal() {
        setState({ ...state, mostrarModal: false, registroAExcluir: {} });
    }

    return (
        <div className="admin-page-container">
            {/* Cabeçalho da Página */}
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Gerenciamento de Inventários</h2>
                    <p className="admin-subtitle">Consulte e organize os registros de inventário do acervo</p>
                </div>
                <Link to="/admin/inventarios/criar/inventario" className="btn-add-new" state={{ acao: "Criar" }}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Inventário
                </Link>
            </div>

            {/* Card de Filtros */}
            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    <Form>
                        <div className="row g-3">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Usuário</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className="input-moderno" 
                                    placeholder="Nome do usuário..." 
                                    name="nome_pessoa" 
                                    value={state.filtros.nome_pessoa} 
                                    onChange={handleChangeFiltros} 
                                />
                            </Form.Group>
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Item</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    className="input-moderno" 
                                    placeholder="Nome do item..." 
                                    name="nome_item" 
                                    value={state.filtros.nome_item} 
                                    onChange={handleChangeFiltros} 
                                />
                            </Form.Group>
                        </div>

                        <div className="d-flex justify-content-start gap-2 mt-4 pt-3 border-top">
                            <Button className="btn-apply-filters" onClick={filtrarInventarios}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" /> Filtrar
                            </Button>
                            <Button className="btn-clear-filters" onClick={limparFiltros}>
                                <FontAwesomeIcon icon={faSync} className="me-2" /> Limpar filtros
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            {/* Tabela de Resultados */}
            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th>Usuário</th>
                                <th>Item</th>
                                <th>Data</th>
                                <th>Observação</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-5">
                                        <div className="spinner-border text-teal"></div>
                                        <div className="mt-2 text-muted">Carregando inventários...</div>
                                    </td>
                                </tr>
                            ) : state.inventarios && state.inventarios.length > 0 ? (
                                state.inventarios.map((item, index) => (
                                    <tr key={index}>
                                        <td data-label="Usuário" className="fw-bold">{item.Usuario.nome_pessoa}</td>
                                        <td data-label="Item">{item.Item.nome_item}</td>
                                        <td data-label="Data">{item.data_inventario}</td>
                                        <td data-label="Observação" className="text-muted small">{item.observacao || '-'}</td>
                                        <td data-label="Opções">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" title="Visualizar" to={"/admin/inventarios/" + item.id_item + "/" + item.sec_inventario} state={{ acao: "" }}>
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Link>
                                                <Link className="action-icon edit" title="Editar" to={"/admin/inventarios/" + item.id_item + "/" + item.sec_inventario} state={{ acao: "Editar" }}>
                                                    <FontAwesomeIcon icon={faPen} />
                                                </Link>
                                                <RequireRoles allowedRoles={['Desenvolvedor']}>
                                                    <button className="action-icon delete" title="Excluir" onClick={() => confirmarExclusao(item)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </RequireRoles>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="5" className="text-center py-4 text-muted">Nenhum inventário encontrado.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {state.inventarios && state.inventarios.length > 0 && (
                    <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                        <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                    </div>
                )}
            </Card>

            {/* Modal de Exclusão Renovada */}
            <Modal show={state.mostrarModal} onHide={fecharModal} centered className="modern-modal">
                <Modal.Header closeButton className="modal-header-teal">
                    <Modal.Title className="text-white fs-5">Excluir Inventário</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p className="mb-0">Você tem certeza que deseja excluir o inventário do item <strong>{state.registroAExcluir.Item?.nome_item}</strong> realizado por <strong>{state.registroAExcluir.Usuario?.nome_pessoa}</strong>?</p>
                </Modal.Body>
                <Modal.Footer className="border-0 p-4 pt-0">
                    <Button variant="light" className="btn-modal-cancel" onClick={fecharModal}>Cancelar</Button>
                    <Button variant="danger" className="px-4" onClick={excluirInventario}>Excluir permanentemente</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}